<template>
  <PopupContent>
    <InfoRow><ActionLink route="profile"><UserIcon class="mr-2" />Профіль</ActionLink></InfoRow>
    <InfoRow><ActionLink :method="logout"><LogoutIcon class="mr-2" />Вийти</ActionLink></InfoRow>
  </PopupContent>
</template>

<script>
import { LogoutIcon, UserIcon } from '@/shared/ui/icons';
import { ActionLink, InfoRow, PopupContent } from '@/shared/ui/popup';

export default {
  components: { PopupContent, InfoRow, ActionLink, UserIcon, LogoutIcon },
  methods: {
    logout() {
      this.$store.dispatch('LOGOUT')
        .then(() => {
          this.$store.dispatch('RESET_CLIENT_BONUS_STATE');
          this.$store.dispatch('RESET_TRANSACTION_STATE');
          this.$store.dispatch('RESET_PAID_ORDERS_STATE');
          window.location.href = this.$router.resolve('/login')?.href;
        });
    },
  },
};
</script>
